import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import style from './style.module.scss';

const TableRow = ({ onRowClick, className, children, dataTestId }) => {
  return (
    <tr
      className={cx(style.row, className, {
        [style.pointer]: onRowClick,
      })}
      onClick={onRowClick}
      data-testid={dataTestId}
    >
      {children}
    </tr>
  );
};

TableRow.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  onRowClick: PropTypes.func,
  dataTestId: PropTypes.string,
};

export default TableRow;
